import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const saveAppointmentsClient = async (appointment) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.saveAppointments()}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(appointment),
    });
    if (!res.ok) {
        return { error: true, message: 'Appointment save request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default saveAppointmentsClient;
